<template>
  <div class="section">
    <slot name="header">
      <h3 class="section-title">{{ customer.id > -1 ? `${customer.name} szerkesztése` : 'Új ügyfél' }}</h3>
    </slot>
    <div class="section-content">
      <b-alert
        :variant="error ? 'danger' : 'success'"
        :show="message.length > 0"
      >
        {{ message }}
      </b-alert>
      <customer-editor v-model="customerData" :errors="errors" @validated="$e => validCustomer = $e"></customer-editor>
      <slot name="footer">
        <div class="section-divider" />
        <b-form-group
          class="text-right"
        >
          <div class="row">
            <div class="col-6 offset-6">
              <b-button
                :disabled="saving || !validCustomer"
                variant="success"
                @click="save"
              >
                <span>Mentés</span>
                <b-spinner
                  v-show="saving"
                  variant="light"
                  label="Mentés"
                  small
                />
              </b-button>
            </div>
          </div>
        </b-form-group>
      </slot>
    </div>
  </div>
</template>
<style>
</style>
<script>
  import VueTagsInput from '@johmun/vue-tags-input'
  import FormValidation from '../../utils/mixins/FormValidation'
  import AddressInput from '../common/AddressInput'

  import emptyCustomer from '../customer/_customer'
  import CustomerEditor from '../customer/CustomerEditor'

  export default {
    components: {
      'customer-editor': CustomerEditor,
      'tags-input': VueTagsInput,
      'address-input': AddressInput
    },
    props: {
      customer: {
        type: Object,
        default: () => (emptyCustomer)
      },
    },
    data() {
      return {
        customerData: emptyCustomer,
        saving: false,
        error: false,
        errors: {},
        validCustomer: true,
        message: '',
      }
    },
    mounted() {
      _.forEach(this.customer, (value, name) => {
        this.customerData[name] = value
      })
    },
    methods: {
      tagsChanged(tags) {
        this.emails = _.map(tags, tag => tag.text)
      },
      save() {
        if(!this.validCustomer) {
          return
        }

        this.message = ''
        this.saving = true
        this.error = false
        this.errors = {}

        this.$http.post(this.$url('profile.customer.update'), this.customerData).then((response) => {
          var data = response.data

          if(data.customer) {
            this.message = 'Sikeres mentés'

          } else {
            this.error = true
            this.message = 'Hiba történt a mentés közben'
          }

          this.$emit('update:customer', data.customer)
        }).catch((err) => {
          this.error = true

          if(!err.response || !err.response.data) {
            this.message = 'Hiba történt a mentés közben'
          }

          var { message, errors } = err.response.data

          if(message) {
            this.message = message
          }

          this.errors = errors
        }).finally(() => {
          this.saving = false
        })
      },
    },
  }
</script>